module.exports = __webpack_public_path__ + "f6ccf47b1c5dae0bf3db78df41038d05.MP3";